import { useState, useEffect, useRef } from 'react'
/**
 * SkillBar — fills via CSS transition when it scrolls into view.
 */
export function SkillBar({ name, pct }) {
  const [filled, setFilled] = useState(false)
  const ref = useRef()
  useEffect(() => {
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setFilled(true); io.disconnect() } }, { threshold: .2 })
    if (ref.current) io.observe(ref.current)
    return () => io.disconnect()
  }, [])
  return (
    <div ref={ref} className="skr">
      <div className="skm"><span>{name}</span><span className="skt">{pct}%</span></div>
      <div className="skb"><div className="skf" style={{ width: filled ? `${pct}%` : '0%' }}/></div>
    </div>
  )
}
